import { getLegacyBindingContext } from "@visactor/vrender-core/legacy/bootstrap";

import { registerRectGraphic } from "@visactor/vrender-core/register/graphic";

import { rectModule } from "@visactor/vrender-core/graphic/modules";

import { browser } from "./env";

import { bindRectCanvasPickerContribution } from "../picker/contributions/canvas-picker/rect-module";

import { bindRectMathPickerContribution } from "../picker/contributions/math-picker/rect-module";

function _registerRect() {
    if (_registerRect.__loaded) return;
    _registerRect.__loaded = !0;
    const legacyContext = getLegacyBindingContext();
    registerRectGraphic(), rectModule({
        bind: legacyContext.bind
    }), browser ? bindRectCanvasPickerContribution(legacyContext) : bindRectMathPickerContribution(legacyContext);
}

_registerRect.__loaded = !1;

export const registerRect = _registerRect;
//# sourceMappingURL=register-rect.js.map